/*
 * @Author: shuaiweige
 * @Date: 2022-05-19 17:55:47
 * @LastEditors:  shuaiweitxd1@163.com
 * @LastEditTime: 2022-05-26 15:53:22
 * @FilePath: \cem-portal-frontend\src\utils\bhooks.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  DELETE_ERROR_TITLE_TIPS,
  SAVE_ERROR_TITLE_TIPS
} from '@/pages/Survey/SurveyManagement/components/SurveyContent/config'
import { reactive, getCurrentInstance } from '@vue/composition-api'
import VueRouter from 'vue-router'
import { Commit, Dispatch } from 'vuex'
import { DELETE_ERROR_TYPE, getErrorCode } from './utils'
import { Loading } from '@gcommon/gcommon-ui'
interface TableRequestState {
  data: Array<any>
  loading: Boolean
  pagination?: TablePagination
  otherRes?: { [key: string]: any }
}
interface TablePagination {
  pageNum?: Number
  pageSize?: Number
  totalCount?: Number
  totalPage?: Number
  total?: Number
}
interface TableRequest {
  state: TableRequestState
  run: Function
}
type Params = {
  params: { [key: string]: any }
  query: { [key: string]: any }
}

interface UseRequest {
  state: UseRequestState
  run: Function
}
interface RequestData {
  code: number
  data: any
  msg: string
}
interface UseRequestState {
  data: RequestData
  loading: Boolean
  success?: boolean
  msg?: string
}
export function useStore() {
  const vm = getCurrentInstance()
  return vm?.proxy.$store
}
export function useSelector(fn) {
  const store = useStore()
  return fn(store?.state)
}
export function useDispatch() {
  const store = useStore()
  return store?.commit as unknown as Commit
}
// 异步dispatch
export function useAsyncDispatch() {
  const store = useStore()
  return store?.dispatch as unknown as Dispatch
}
export function useHistory() {
  const vm = getCurrentInstance()
  return vm?.proxy.$router as unknown as VueRouter
}
export function useParams(): Params {
  const vm = getCurrentInstance()
  const { query, params } = vm?.proxy.$store as unknown as Params
  return { params, query }
}
export function useTableRequest(
  services,
  hasPagination = true,
  hasOtherRes = false
): TableRequest {
  const state = reactive<TableRequestState>(
    hasPagination
      ? {
        data: [],
        loading: false,
        pagination: {}
      }
      : {
        data: [],
        loading: false
      }
  )
  const run = (params) => {
    state.loading = true
    return new Promise((resloved, rejected) => {
      services(params)
        .then((res) => {
          let data = []
          state.loading = false
          // 有些表格没有分页出参res.data.page
          if (hasPagination) {
            data = res?.data?.data ?? []
            if (res?.data?.page) {
              res.data.page.total = res?.data?.page?.totalCount ?? 0
            } else {
              if (res.data) {
                res.data['page'] = { total: 0 }
              } else {
                res['data'] = {
                  page: { total: 0 }
                }
              }
            }
            state.pagination = res?.data?.page
            if (hasOtherRes) {
              state.otherRes = res.data
            }
          } else {
            data = res?.data
          }
          state.data = data ?? []
          resloved(res)
        })
        .catch((e) => {
          rejected(e)
        })
        .finally(() => {
          state.loading = false
        })
    })
  }
  return { state, run }
}
export function useRequest(service): UseRequest {
  const { app } = useSelector(({ app }) => ({ app }))
  const state = reactive<UseRequestState>({
    data: [],
    loading: false
  })
  const commit = useDispatch()
  const run = (params) => {
    state.loading = true
    commit('app/SET_LOADING', true)
    //不需要提示的code
    const noTips = [200, 30024, 30025, 30026, 30027, 30028, 30029, 30030, 30031, 30032]
    return new Promise((resolved, rejected) => {
      service(params)
        .then((res) => {
          state.data = res
          state.loading = false
          commit('app/SET_LOADING', false)
          if (res?.code !== 200) {
            if (!noTips.includes(res?.code)) {
              state.success = false
              state.msg = res.msg
              //非200的状态码做统一错误提示
              if (getErrorCode(res?.code)) {
                commit('errorTips/setErrorTips', {
                  isVisible: true,
                  data: res.data
                    ? Array.isArray(res.data)
                      ? res.data
                      : [res.data]
                    : [],
                  title: DELETE_ERROR_TYPE.includes(res.code)
                    ? DELETE_ERROR_TITLE_TIPS()
                    : SAVE_ERROR_TITLE_TIPS(),
                  subTitle: getErrorCode(res?.code)
                })
              }
            }
          } else {
            state.success = true
            state.msg = res.msg
          }
          resolved(res)
        })
        .catch((e) => {
          state.success = false
          rejected(e)
        })
        .finally(() => {
          // loadingInstance.close()
          state.loading = false
          commit('app/SET_LOADING', false)
        })
    })
  }
  return { state, run }
}

export function useDebounceFn<T extends Function>(fn: T, delay = 200): T {
  if (delay <= 0) return fn

  let timer: ReturnType<typeof setTimeout> | undefined

  function wrapper(this: any, ...args: any[]) {
    const exec = () => {
      timer = undefined
      return fn.apply(this, args)
    }
    // 如果已经存在时间回调，重新刷新定时器
    if (timer) clearTimeout(timer)

    timer = setTimeout(exec, delay)
  }

  return wrapper as any as T
}

export function useThrottleFn<T extends Function>(
  fn: T,
  delay = 200,
  trailing = true
): T {
  if (delay <= 0) return fn

  let lastExec = 0
  let timer: ReturnType<typeof setTimeout> | undefined
  let lastThis: any
  let lastArgs: any[]

  function clear() {
    if (timer) {
      clearTimeout(timer)
      timer = undefined
    }
  }

  function timeoutCallback() {
    clear()
    fn.apply(lastThis, lastArgs)
  }

  function wrapper(this: any, ...args: any[]) {
    const elapsed = Date.now() - lastExec

    clear()
    // 比较上一次执行的事件和这次的gap
    if (elapsed > delay) {
      lastExec = Date.now()
      fn.apply(this, args)
    } else if (trailing) {
      // 记录当前执行栈的上下文
      lastArgs = args
      lastThis = this
      timer = setTimeout(timeoutCallback, delay)
    }
  }

  return wrapper as any as T
}
